import React from 'react';
import useMutationObserver from 'beautiful-react-hooks/useMutationObserver';
import { Discounts } from './types';

interface PromoCodeListenerProps {
  setDiscounts: React.Dispatch<React.SetStateAction<Discounts>>;
  setShowPromoCodes: React.Dispatch<React.SetStateAction<boolean>>;
}

export const PromoCodeListener: React.FC<PromoCodeListenerProps> = ({
  setShowPromoCodes,
  setDiscounts,
}) => {
  // When a promo code is added, we update the chart's pricing configuration to show the discounted prices,
  // and also save the discounts in the state.
  React.useEffect(() => {
    const promoCodeAddedHandler = (e: CustomEvent<Discounts>) => {
      setDiscounts(e.detail);
    };
    window.addEventListener('seatsio.promoCodeAdded', promoCodeAddedHandler as EventListener);
    return () =>
      window.removeEventListener('seatsio.promoCodeAdded', promoCodeAddedHandler as EventListener);
  }, [setDiscounts]);

  // When the ticket/seat is selected/deselected, JS code in users2.js sets the remaining quantity of promo codes.
  // When there are no promo codes left, we hide the promo codes from the chart, so new selections show the original prices again.
  useMutationObserver(
    { current: document.getElementById('get-promocode-code') },
    (mutations, _observer) => {
      mutations
        .filter(m => m.attributeName === 'promocode-max-qty')
        .forEach(mutation => {
          const target = mutation.target as HTMLElement;
          const maxQty = parseInt(target.getAttribute('promocode-max-qty') || '0', 10);

          if (maxQty === 0) {
            setShowPromoCodes(false);
          } else {
            setShowPromoCodes(true);
          }
        });
    },
    { attributeFilter: ['promocode-max-qty'] },
  );
  return <></>;
};
